import Vue from "vue";
import switchTheme from "@/mixins/switchTheme";

Vue.mixin(switchTheme);
